// extracted by mini-css-extract-plugin
export default {"container":"App_container__4L7Vo","shifted":"App_shifted__fC9Yp"};